export const TID = {
    // header
    logo: "header-logo",
    navHome: "nav-home",
    navMasalas: "nav-masalas",
    navDecor: "nav-decor",
    navJewelry: "nav-jewelry",
    navShop: "nav-shop",
    navAdmin: "nav-admin",
    navAccount: "nav-account",
    navLogin: "nav-login",
    navLogout: "nav-logout",
    navRegister: "nav-register",
    navCart: "nav-cart",
    langBtn: "lang-switcher-btn",
    langOption: (code) => `lang-option-${code}`,
    // home
    heroCta: "hero-cta-shop",
    heroCta2: "hero-cta-story",
    verticalMasalas: "vertical-card-masalas",
    verticalDecor: "vertical-card-decor",
    verticalJewelry: "vertical-card-jewelry",
    // product card
    productCard: (slug) => `product-card-${slug}`,
    addToCart: (slug) => `add-to-cart-${slug}`,
    // product detail
    pdAddCart: "pd-add-cart",
    pdBuyNow: "pd-buy-now",
    pdQty: "pd-qty",
    // shop filters
    filterAll: "filter-all",
    filterMasalas: "filter-masalas",
    filterDecor: "filter-decor",
    filterJewelry: "filter-jewelry",
    // cart
    cartCheckout: "cart-checkout",
    cartClear: "cart-clear",
    cartRemove: (slug) => `cart-remove-${slug}`,
    cartQty: (slug) => `cart-qty-${slug}`,
    // auth
    loginEmail: "login-email",
    loginPassword: "login-password",
    loginSubmit: "login-submit",
    registerEmail: "register-email",
    registerPassword: "register-password",
    registerName: "register-name",
    registerSubmit: "register-submit",
    // admin
    adminStat: (k) => `admin-stat-${k}`,
    adminTabProducts: "admin-tab-products",
    adminTabOrders: "admin-tab-orders",
    adminTabUsers: "admin-tab-users",
};
